import { MultiRangeSlider } from './MultiRange';
import { SingleSlider } from './Single';

export const Slider = {
  Single: SingleSlider,
  Multi: MultiRangeSlider,
};
